import { Tag, type TagProps } from '@/components';
import { type ColorOptions, getTagStyles } from '@/utils';
import type { FC } from 'react';

type Props = Omit<TagProps, 'color'> & {
  color?: ColorOptions;
};

export const FeatureTag: FC<Props> = ({ color = 'gray', ...props }) => {
  return (
    <Tag
      {...props}
      style={{
        borderRadius: 11,
        border: '1px solid',
        ...getTagStyles(color),
      }}
    />
  );
};
